import { createSelector } from 'reselect';
/**
 * @description Selector Function for getting the specified state from reducer
 */
const getHeaderState = state => state.header;
export const getSupportBrands = () => createSelector(getHeaderState, substate => {
  const {
    supportBrands
  } = substate;
  return supportBrands;
});
export const getTicketFields = () => createSelector(getHeaderState, substate => {
  const {
    ticketFields
  } = substate;
  return ticketFields;
});
export const getTicketLoading = () => createSelector(getHeaderState, substate => {
  const {
    ticketLoading
  } = substate;
  return ticketLoading;
});
export const getTicketDrawerApiStatus = () => createSelector(getHeaderState, substate => {
  const {
    ticketDrawerApiStatus
  } = substate;
  return ticketDrawerApiStatus;
});
export const getTicketCreationFields = () => createSelector(getHeaderState, substate => {
  const {
    ticketCreationFields
  } = substate;
  return ticketCreationFields;
});
export const getSupportForms = () => createSelector(getHeaderState, substate => {
  const {
    supportForms
  } = substate;
  return supportForms;
});
export const getGroupsLookup = () => createSelector(getHeaderState, substate => {
  const {
    groups
  } = substate;
  return groups;
});
export const getLoadingStatus = () => createSelector(getHeaderState, substate => {
  const {
    loading
  } = substate;
  return loading;
});
export const getEmail = () => createSelector(getHeaderState, substate => {
  const {
    email
  } = substate;
  return email;
});
export const makeUserDetails = () => createSelector(getHeaderState, substate => substate.userDetails);
export const makeFetchApiStatus = () => createSelector(getHeaderState, substate => substate.isFetchApiCalled);
export const getIsPartnerSite = () => createSelector(getHeaderState, substate => substate.isPartnerSite);
export const getChatS3Url = () => createSelector(getHeaderState, substate => substate.chatS3Url);
export const getUserNotifications = () => createSelector(getHeaderState, substate => substate.notifications);
export const gethasMoreNotification = () => createSelector(getHeaderState, substate => substate.hasMore);
export const getNotificationLoading = () => createSelector(getHeaderState, substate => substate.notificationLoading);
export const getUnreadNotificationsCount = () => createSelector(getHeaderState, substate => substate.unreadNotificationsCount);
export const getNotificationFilter = () => createSelector(getHeaderState, substate => substate.notificationFilter);
export const getUserTodos = () => createSelector(getHeaderState, substate => substate.todos);
export const getTodoLoading = () => createSelector(getHeaderState, substate => substate.todoLoading);
export const getPusherCred = () => createSelector(getHeaderState, substate => substate.pusherCred);